import { Outlet } from "react-router-dom"
import ApolloClientProvider from "@/v1-console/apollo/ApolloClientProvider"
import AppContextLoader from "@/v1-console/app/context/AppContextLoader"
import AppSidebar from "@/v1-console/app/sidebar/AppSidebar"
import AppReadyIndicator from "@/v1-console/app/AppReadyIndicator"
import HubspotChatSuspender from "@/v1-console/hubspot/HubspotChatSuspender"
import NotificationSubscriber
  from "@/v1-console/notification/NotificationSubscriber"

function AppOutlet() {
  return (
    <ApolloClientProvider>
      <AppContextLoader>
        <AppSidebar />
        <Outlet />
        <HubspotChatSuspender />
        <AppReadyIndicator />
      </AppContextLoader>
      <NotificationSubscriber />
    </ApolloClientProvider>
  )
}

export default AppOutlet
